import { render, staticRenderFns } from "./TabBudgetDestination.vue?vue&type=template&id=7b871275&scoped=true"
import script from "./TabBudgetDestination.vue?vue&type=script&lang=ts"
export * from "./TabBudgetDestination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b871275",
  null
  
)

export default component.exports